var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navegacao',{ref:"navegacaoMenu"}),_c('v-main',{},[_c('div',{staticClass:"barra-lateral"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }